import React, { Component } from 'react';
import './App.css';
import Main from './components/Main'
import index from './engines/index'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'

import logo from './media/logo2.svg'
import ditherBackground from './media/Dither Background.mp4'
import ditherBackgroundImage from './media/Dither Background Image.jpg'
import { Dispatch, Modal } from 'architecture'
import Auth from './components/Auth'

//Temp import
import { ajax } from 'rxjs/ajax';

//Temp hit of database to turn it on (heroku)
ajax({ url: 'https://shipper-99cfc751dc.herokuapp.com/backend/dev', method: 'GET', responseType: 'json' })
  .subscribe();

class App extends Component {
  render() {
    let view = this.props.view
    view = 'chat'
    return (
      <div>
        <Modal {...this.props} />
        {view !== 'chat' ?
          <div>
            <div className='fixed w-100 h3 bg-dark-gray'>
              <div className='h3 w-100 mw8 center f4 fw4 fw3-ns flex justify-between items-end'>
              
                  <div className='pv1 ph2'></div>
                  <div className='pv2 ph2 f2 white pointer' onClick={e => Dispatch.nextAction('navigate', 'chat')}><FontAwesomeIcon icon={faSignInAlt}/></div>
              
              </div>
            </div>
            <div className='fixed w-100 vh-100' style={{zIndex: -2}}>
              {/* <video src={ditherBackground} poster={ditherBackgroundImage} className='db' style={{opacity: '.1', minWidth: '100%', minHeight: '100%', zIndex: -2, position: 'relative', left: '50%', transform: 'translateX(-50%) translateY(-50%)', top: '50%'}} autoPlay loop muted playsInline>

              </video> */}
            </div>
            <div className='w-100 vh-100 flex items-center justify-center'>
              <img className='w-75 mw8' src={logo} alt='logo'/>
            </div>
          </div>
        :
          this.props.auth && this.props.auth.user ? 
            <Main {...this.props} />
            :
            <div className='pb5 vh-100 w-100 mw7 avenir center flex justify-center items-center'>
              <Auth {...this.props} />
            </div>
        }
      </div>
    );
  }
}

export default App;
